import React from "react";
import { Card } from "antd";

const FrameworkSection = ({ icon: Icon, color, title, description, categories }) => (
  <Card className={`p-2 mx-4 rounded-xl card-border ${color}`}>
    <div className="items-start gap-1.5">
      <div className="flex items-center gap-1">
        <Icon className={`icon-color ${color} h-5 w-5`} />
        <h4 className="flex text-[16px]">{title}</h4>
      </div>
      <p className="text-gray-700">{description}</p>
    </div>

    {categories.map(({ title: catTitle, items }) => (
      <div key={catTitle} className="mt-3 space-y-1">
        <p className="font-semibold text-[14px]">{catTitle}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {items.map(({ label, color, text }) => (
            <div key={label} className={`p-2 rounded border bg-${color}-50`}>
              <p className={`text-[11px] font-medium label-color ${label.toLowerCase().replace(/\s+/g, "-")}`}>{label}</p>
              <p className="text-[11px] text-muted-foreground">{text}</p>
            </div>
          ))}
        </div>
      </div>
    ))}
  </Card>
);
export default FrameworkSection;